import { Component } from "@theme/component";

/**
 * @typedef {object} Refs
 * @property {HTMLElement[]} [tabButtons]
 * @property {HTMLElement[]} [panels]
 *
 * @extends {Component<Refs>}
 */
class ProductRankings extends Component {
  /** @type {HTMLButtonElement[]} */
  #tabButtons = [];
  /** @type {HTMLElement[]} */
  #panels = [];

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    this.#tabButtons = Array.from(this.querySelectorAll('[ref="tabButtons"]'));
    this.#panels = Array.from(this.querySelectorAll('[ref="panels"]'));

    if (this.#tabButtons.length === 0 || this.#panels.length === 0) return;

    this.#initEvents();
    this.#activate(0);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  #initEvents() {
    // JSDocで配列だと定義されているので、エディタの補完も完璧に効きます
    this.#tabButtons.forEach((btn, i) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.#activate(i);
      });

      btn.addEventListener("keydown", (event) => {
        const key = event.key;
        if (key === "ArrowRight" || key === "ArrowLeft") {
          event.preventDefault();
          const dir = key === "ArrowRight" ? 1 : -1;
          const next =
            (i + dir + this.#tabButtons.length) % this.#tabButtons.length;

          this.#tabButtons[next]?.focus();
          this.#activate(next);
        }
      });
    });
  }

  /**
   * パネルのアクティブ化
   * @param {number} index
   */
  #activate(index) {
    this.#tabButtons.forEach((btn, i) => {
      const selected = i === index;
      btn.classList.toggle("is-active", selected);
      btn.setAttribute("aria-selected", selected ? "true" : "false");

      const panel = this.#panels[i];
      if (panel) {
        panel.classList.toggle("hidden", !selected);
        panel.setAttribute("aria-hidden", !selected ? "true" : "false");
      }
    });
  }
}

if (!customElements.get("product-rankings")) {
  customElements.define("product-rankings", ProductRankings);
}
